import { TypedUseSelectorHook, useDispatch as dispatch, useSelector as selector } from 'react-redux';

import { Dispatch, Store } from 'store/configureStore';

export const useDispatch = () => dispatch<Dispatch>();
export const useSelector: TypedUseSelectorHook<Store> = selector;
